import { Button, Space } from 'antd'
import microsoftIcon from 'assets/images/login/microsoft.png'
import login from 'modules/login'
import React from 'react'
import { connect } from 'react-redux'
import { onRedirect } from './utils'

const LoginOtherContainer = ({
  tenantIdMicrosoftLogin,
  dominioMicrosoftLogin,
  tenantIdByDominio,
  azureRedirect,
  whoAmI,
}) => {
  const containerButtonStyle = {
    display: 'flex',
    justifyContent: 'center',
  }

  // Obtener tenant_id de la URL si existe
  const urlParams = new URLSearchParams(window.location.search)
  const tenantId = urlParams.get('tenant_id')

  const renderTenantIdAzure = () => {
    if (dominioMicrosoftLogin) {
      return tenantId
    } else {
      return tenantIdByDominio
    }
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div style={containerButtonStyle}>
        <Button
          type="default"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 250,
            height: 40,
            borderRadius: 6,
            backgroundColor: '#ffffff',
            border: '1px solid #d9d9d9',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: 15,
            fontWeight: 500,
          }}
          onClick={() => onRedirect(() => azureRedirect(renderTenantIdAzure()), whoAmI)}
        >
          <img
            src={microsoftIcon}
            alt="Microsoft"
            style={{
              width: 20,
              height: 20,
              objectFit: 'contain',
              marginRight: 8,
            }}
          />
          Sign in with Microsoft
        </Button>
      </div>
    </Space>
  )
}

const mapDispatchToProps = {
  azureRedirect: login.actions.azureRedirect,
  whoAmI: login.actions.whoAmI,
}

export default connect(null, mapDispatchToProps)(LoginOtherContainer)
